import WidgetTitle from './WidgetTitle';

export default WidgetTitle;
